import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news41Img from "../../images/news/news4/news4_1.jpg";
import news42Img from "../../images/news/news4/news4_2.jpg";
import news43Img from "../../images/news/news4/news4_3.jpg";
import news44Img from "../../images/news/news4/news4_4.jpg";
import news45Img from "../../images/news/news4/news4_5.jpg";
import news46Img from "../../images/news/news4/news4_6.jpg";
import news47Img from "../../images/news/news4/news4_7.jpg";
import news48Img from "../../images/news/news4/news4_8.jpg";
import news49Img from "../../images/news/news4/news4_9.jpg";
import news410Img from "../../images/news/news4/news4_10.jpg";
import news411Img from "../../images/news/news4/news4_11.jpg";
import news412Img from "../../images/news/news4/news4_12.jpg";
import news413Img from "../../images/news/news4/news4_13.jpg";
import news414Img from "../../images/news/news4/news4_14.jpg";
import news415Img from "../../images/news/news4/news4_15.jpg";
import news416Img from "../../images/news/news4/news4_16.jpg";
import news417Img from "../../images/news/news4/news4_17.jpg";
import news418Img from "../../images/news/news4/news4_18.jpg";
import news419Img from "../../images/news/news4/news4_19.jpg";
import news420Img from "../../images/news/news4/news4_20.jpg";
import news421Img from "../../images/news/news4/news4_21.jpg";
import news422Img from "../../images/news/news4/news4_22.png";
import news423Img from "../../images/news/news4/news4_23.jpg";
import news424Img from "../../images/news/news4/news4_24.jpg";
import news425Img from "../../images/news/news4/news4_25.jpg";
import news426Img from "../../images/news/news4/news4_26.jpg";
import news427Img from "../../images/news/news4/news4_27.jpg";
import news428Img from "../../images/news/news4/news4_28.jpg";

import { withTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

class news4 extends Component {
    componentDidMount() {}

    componentWillMount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("News4_Title");
    }

    componentWillUnmount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("Home_Title");
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <Header />

                <div className="page-content">
                    <div
                        className="page-banner ovbl-dark"
                        style={{ backgroundImage: "url(" + bannerImg + ")" }}
                    >
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">{t("News4_Title")}</h1>
                            </div>
                        </div>
                    </div>

                    <div className="breadcrumb-row">
                        <div className="container">
                            <ul className="list-inline">
                                <li>
                                    <Link to="/">{t("News4_LinkHome")}</Link>
                                </li>
                                <li>{t("News4_LinkCourses")}</li>
                            </ul>
                        </div>
                    </div>

                    <div className="content-block">
                        <div className="section-area section-sp1">
                            <div className="container">
                                <div className="row d-flex flex-row-reverse">
                                    <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
                                        <div className="courses-post">

                                            <h1>{t("News4_Content_H")}</h1>

                                            {/* // 1 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news41Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P1")}</ReactMarkdown>

                                            {/* // 2 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news42Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P2")}</ReactMarkdown>

                                            {/* // 3 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news43Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P3")}</ReactMarkdown>

                                            {/* // 4 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news44Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P4")}</ReactMarkdown>

                                            {/* // 5 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news45Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P5")}</ReactMarkdown>

                                            {/* // 6 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news46Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P6")}</ReactMarkdown>

                                            {/* // 7 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news47Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P7")}</ReactMarkdown>

                                            {/* // 8 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news48Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P8")}</ReactMarkdown>

                                            {/* // 9 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news49Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P9")}</ReactMarkdown>

                                            {/* // 10 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news410Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P10")}</ReactMarkdown>

                                            {/* // 11 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news411Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P11")}</ReactMarkdown>

                                            {/* // 12 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news412Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P12")}</ReactMarkdown>

                                            {/* // 13 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news413Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P13")}</ReactMarkdown>

                                            {/* // 14 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news414Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P14")}</ReactMarkdown>

                                            {/* // 15 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news415Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P15")}</ReactMarkdown>

                                            {/* // 16 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news416Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P16")}</ReactMarkdown>

                                            {/* // 17 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news417Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P17")}</ReactMarkdown>

                                            {/* // 18 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news418Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P18")}</ReactMarkdown>

                                            {/* // 19 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news419Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P19")}</ReactMarkdown>

                                            {/* // 20 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news420Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P20")}</ReactMarkdown>

                                            {/* // 21 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news421Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P21")}</ReactMarkdown>

                                            {/* // 22 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news422Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P22")}</ReactMarkdown>

                                            {/* // 23 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news423Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P23")}</ReactMarkdown>

                                            {/* // 24 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news424Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P24")}</ReactMarkdown>

                                            {/* // 25 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news425Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P25")}</ReactMarkdown>

                                            {/* // 26 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news426Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P26")}</ReactMarkdown>

                                            {/* // 27 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news427Img}
                                                    alt=""
                                                    width={300}
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P27")}</ReactMarkdown>

                                            {/* // 28 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news428Img}
                                                    alt=""
                                                    width={300}
                                                />
                                            </div>
                                            <ReactMarkdown>{t("News4_Content_P28")}</ReactMarkdown>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </>
        );
    }
}

export default news4 = withTranslation()(news4);
